// Bidding strategy options
export const BIDDING_STRATEGY = {
  FACILITY_MAX_BID: 'facility_max_bid',
  SMART_RECOMMENDATIONS: 'smart_recommendations',
};

export const BIDDING_STRATEGY_OPTIONS = [
  { label: 'Facility Max Bid', value: BIDDING_STRATEGY.FACILITY_MAX_BID },
  { label: 'Smart Recommendations', value: BIDDING_STRATEGY.SMART_RECOMMENDATIONS },
];

export const BIDDING_STRATEGY_COLORS = {
  [BIDDING_STRATEGY.FACILITY_MAX_BID]: 'blue',
  [BIDDING_STRATEGY.SMART_RECOMMENDATIONS]: 'green',
};

// Optimization strategy options
export const OPTIMIZATION_STRATEGY = {
  LINEAR: 'linear',
  NEIGHBOR_QUE: 'neighbor_que',
};

export const OPTIMIZATION_STRATEGY_OPTIONS = [
  { label: 'Facility Max Bid', value: OPTIMIZATION_STRATEGY.NEIGHBOR_QUE },
  { label: 'Smart Recommendations', value: OPTIMIZATION_STRATEGY.LINEAR },
];

export const OPTIMIZATION_STRATEGY_COLORS = {
  [OPTIMIZATION_STRATEGY.LINEAR]: 'purple',
  [OPTIMIZATION_STRATEGY.NEIGHBOR_QUE]: 'orange',
};

// Notification frequency options
export const NOTIFICATION_FREQUENCY = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  OFF: 'off',
};

export const NOTIFICATION_FREQUENCY_OPTIONS = [
  { label: 'Daily', value: NOTIFICATION_FREQUENCY.DAILY },
  { label: 'Weekly', value: NOTIFICATION_FREQUENCY.WEEKLY },
  { label: 'Monthly', value: NOTIFICATION_FREQUENCY.MONTHLY },
  { label: 'Off', value: NOTIFICATION_FREQUENCY.OFF },
];

// Day of week options
export const DAY_OF_WEEK = {
  MON: 1,
  TUES: 2,
  WED: 3,
  THUR: 4,
  FRI: 5,
  SAT: 6,
  SUN: 7,
};

export const DAY_OF_WEEK_OPTIONS = [
  { label: 'Monday', value: DAY_OF_WEEK.MON },
  { label: 'Tuesday', value: DAY_OF_WEEK.TUES },
  { label: 'Wednesday', value: DAY_OF_WEEK.WED },
  { label: 'Thursday', value: DAY_OF_WEEK.THUR },
  { label: 'Friday', value: DAY_OF_WEEK.FRI },
  { label: 'Saturday', value: DAY_OF_WEEK.SAT },
  { label: 'Sunday', value: DAY_OF_WEEK.SUN },
];

// User roles
export const USER_ROLE = {
  GLOBAL_ADMIN: 'global_admin',
  ADMIN: 'administrator',
  USER: 'user',
};

export const USER_ROLE_LABELS = {
  [USER_ROLE.GLOBAL_ADMIN]: 'Global Administrator',
  [USER_ROLE.ADMIN]: 'Admin',
  [USER_ROLE.USER]: 'User',
};

// Roles available for creating users (excludes global_admin)
export const USER_ROLE_OPTIONS = [
  { label: USER_ROLE_LABELS[USER_ROLE.ADMIN], value: USER_ROLE.ADMIN },
  { label: USER_ROLE_LABELS[USER_ROLE.USER], value: USER_ROLE.USER },
];

// Avatar color palette for user avatars
export const AVATAR_COLORS = [
  '#f56a00', // orange
  '#7265e6', // purple
  '#ffbf00', // gold
  '#00a2ae', // teal
  '#eb2f96', // magenta
  '#52c41a', // green
  '#1890ff', // blue
  '#722ed1', // violet
  '#13c2c2', // cyan
  '#fa541c', // volcano
];

// Timezone options
export const TIMEZONE = {
  EASTERN: 'America/New_York',
  CENTRAL: 'America/Chicago',
  MOUNTAIN: 'America/Denver',
  PACIFIC: 'America/Los_Angeles',
};

export const TIMEZONE_OPTIONS = [
  { label: '(UTC-05:00) Eastern Time', value: TIMEZONE.EASTERN },
  { label: '(UTC-06:00) Central Time', value: TIMEZONE.CENTRAL },
  { label: '(UTC-07:00) Mountain Time', value: TIMEZONE.MOUNTAIN },
  { label: '(UTC-08:00) Pacific Time', value: TIMEZONE.PACIFIC },
];

// Scheduler labels and colors
export const SCHEDULER_GROUP_LABELS = {
  AUTO_PUBLISH: 'Auto Publish',
  GLOBAL: 'Global',
  REMINDER: 'Reminder',
  NOTIFICATION: 'Notification',
};

export const SCHEDULER_TYPE_COLORS = {
  AUTO_PUBLISH: 'blue',
  REMINDER: 'gold',
  NOTIFICATION: 'purple',
};
